import { compR } from "../func/compr";
import { iterator1 } from "../iterator";
export function map(fn, src) {
  return src ? iterator1(map(fn), src) : function (rfn) {
    var r = rfn[2];
    return compR(rfn, function (acc, x) {
      return r(acc, fn(x));
    });
  };
}